import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { PrivilegesUsers } from '@core/privileges/privileges-users';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.client.head'),
        url: RouteEntity.Root + RouteEntity.Clients,
        objName: [
            PrivilegesModules.SupportClients,
            PrivilegesModules.SupportRefunds,
        ],
    },
    {
        mdId: 2,
        mdName: marker('modules.refunds.head'),
        url: RouteEntity.Root + RouteEntity.Refunds,
        objName: [PrivilegesModules.SupportRefunds],
    },
    {
        mdId: 3,
        mdName: marker('global.labels.coupons'),
        url: RouteEntity.Root + RouteEntity.CouponSearch,
        objName: [PrivilegesModules.SupportClients],
        needPrivilegeForView: [{
            [PrivilegesModules.SupportClients]: [PrivilegesUsers.Edit, PrivilegesUsers.Select],
        }],
    },
    {
        mdId: 4,
        mdName: marker('global.labels.tickets'),
        url: RouteEntity.Root + RouteEntity.TicketSearch,
        objName: [PrivilegesModules.SupportClients],
        needPrivilegeForView: [{
            [PrivilegesModules.SupportClients]: [PrivilegesUsers.Edit, PrivilegesUsers.Select],
        }],
    },
    {
        mdId: 5,
        mdName: marker('modules.messages.head'),
        url: RouteEntity.Root + RouteEntity.Messages,
        objName: [PrivilegesModules.SupportClients],
    },
];


export const thirdLevelMenu: { [key: string]: MenuItemsModel[] } = {
    clients: [
        {
            mdId: 1,
            mdName: marker('support.submenu.clients.about'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Clients +
                '/#' + RoutingQueryParamsName.ClientId + '#/' +
                RouteEntity.About,
        },
        {
            mdId: 5,
            mdName: marker('global.labels.privileges'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Clients +
                '/#' + RoutingQueryParamsName.ClientId + '#/' +
                RouteEntity.Privileges,
        },
        {
            mdId: 2,
            mdName: marker('support.submenu.clients.history'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Clients +
                '/#' + RoutingQueryParamsName.ClientId + '#/' +
                RouteEntity.History,
        },
        {
            mdId: 3,
            mdName: marker('support.submenu.clients.parking'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Clients +
                '/#' + RoutingQueryParamsName.ClientId + '#/' +
                RouteEntity.Parking,
        },
        {
            mdId: 4,
            mdName: marker('support.submenu.clients.courtesy'),
            urlTemplate:
                RouteEntity.Root +
                RouteEntity.Clients +
                '/#' + RoutingQueryParamsName.ClientId + '#/' +
                RouteEntity.Courtesy,
        },
    ],
};
